export function isEven(n: number) {
    return n % 2 === 0;
}

export function isOdd(n: number) {
    return Math.abs(n % 2) === 1;
}
